import { useEffect } from "react";
import type { Question } from "@/schema/quizSchema";
import { useStrings } from "@/i18n/LocaleContext";
import { Testimonial } from "@/components/Testimonial";

type InfoQuestion = Extract<Question, { type: "info" }>;

export function Info({
  question,
  onAnswer,
}: {
  question: InfoQuestion;
  onAnswer: (value: null) => void;
}) {
  const t = useStrings();
  const auto = question.autoAdvanceMs;
  useEffect(() => {
    if (auto === undefined) return;
    const timer = setTimeout(() => onAnswer(null), auto);
    return () => clearTimeout(timer);
  }, [auto, onAnswer]);

  return (
    <div>
      <h2 style={{ fontFamily: "var(--font-title)", fontSize: "var(--type-info-heading)", lineHeight: "var(--leading-title)", margin: "0 0 0.75rem" }}>
        {question.heading}
      </h2>
      {question.image && (
        <img
          className="qk-info-img"
          src={question.image}
          alt={question.imageAlt ?? ""}
          loading="lazy"
          data-qk-info-img
        />
      )}
      {question.body.map((line, i) => (
        <p key={i} style={{ color: "var(--color-muted)", margin: "0 0 0.5rem" }}>
          {line}
        </p>
      ))}
      {question.cards && question.cards.length > 0 && (
        <div className="qk-cards" data-qk-cards>
          {question.cards.map((card, i) => (
            <figure className="qk-card" key={i}>
              <img
                className="qk-card-img"
                src={card.image}
                alt={card.imageAlt ?? card.title}
                loading="lazy"
              />
              <figcaption className="qk-card-text">
                <span className="qk-card-title">{card.title}</span>
                <span className="qk-card-desc">{card.description}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      )}
      {question.testimonial && <Testimonial data={question.testimonial} />}
      <button type="button" className="qk-cta" onClick={() => onAnswer(null)}>
        {t.continueLabel}
      </button>
    </div>
  );
}
